import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ThemeProvider from "./theme/theme-provider";
import ReactGA from "react-ga4";
import clarity from "@microsoft/clarity";

const GAID = "G-MBNKCNJKPH";
ReactGA.initialize(GAID);
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

// Microsoft Clarity
clarity.init("ufsytkjqko");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <ThemeProvider>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <App />
            </GoogleOAuthProvider>
        </ThemeProvider>
    </Provider>
);
